<template>
    <div class="page-block | u-margin-bottom-narrow">
        <div class="page-block__item-wrapper" v-if="customer">
            <h2 class="page-block__title | u-font-weight-normal">{{ trans('profile.customer.title') }}</h2>
            <div class="page-block__item">
                <div class="page-block__item-content">
                    <Profile-customer-general :customer="customer" />
                    <Profile-customer-address :customer="customer.address" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ProfileCustomerGeneral from './ProfileCustomerGeneral.vue';
import ProfileCustomerAddress from './ProfileCustomerAddress.vue';

export default {
    components: {
        ProfileCustomerGeneral,
        ProfileCustomerAddress
    },
    props: {
        customer: {
            type: Object,
            default: () => {}
        }
    }
};
</script>
